import React from 'react'
import Footer from './Footer'
import Header from './Header'

const About = () => {
  return (
    <>
    <Header/>
    {/* Intitial Loder not working i don't know the reason hence commented the code */}

    
    {/* <div class="loading-page" id="preloader-active">
        <div class="counter">
            <img src="assets/images/logo/logo.png" alt="img"/>
            <span class="number">0%</span>
            <span class="line"></span>
            <span class="line"></span>
        </div>
    </div> */}
    
    <main>
        {/* <!-- Breadcrumbs S t a r t --> */}
        <section class="breadcrumb-section breadcrumb-bg">
            <div class="container">
                <div class="row">
					<div class="col-lg-12">
                        <div class="breadcrumb-text">
                            <h1 class="title wow fadeInUp" data-wow-delay="0.1s">About Us</h1>
                            <nav aria-label="breadcrumb" class="breadcrumb-nav wow fadeInUp" data-wow-delay="0.0s">
                                <ul class="breadcrumb listing">
                                    <li class="breadcrumb-item single-list"><a href="index.html" class="single">Home</a></li>
                                    <li class="breadcrumb-item single-list" aria-current="page"><a href="javascript:void(0)"
                                            class="single active">About Us</a></li>
                                </ul>
                            </nav>
                        </div>
					</div>
				</div>
            </div>
        </section>
        {/* <!-- End-of Breadcrumbs--> */}

		{/* <!-- Goal area S t a r t --> */}
		<section class="goal-area position-relative">
			<div class="container">
				<div class="row g-4">
					<div class="col-xxl-3 col-md-4 col-sm-6">
						<div class="goal-card wow fadeInUp" data-wow-delay="0.0s">
							<div class="circle-icon">
								<img src="assets/images/goal/icon-1.png" alt="img"/>
							</div>
							<a href="javascript:void(0)">
								<h4 class="title line-clamp-1 text-color-primary">Original Product</h4>
								<p class="pera text-color-tertiary line-clamp-2">There are many variations of passages
									of our
									Lorem Ipsum available but the.</p>
							</a>
						</div>
					</div>
					<div class="col-xxl-3 col-md-4 col-sm-6">
						<div class="goal-card wow fadeInUp" data-wow-delay="0.0s">
							<div class="circle-icon">
								<img src="assets/images/goal/icon-2.png" alt="img"/>
							</div>
							<a href="javascript:void(0)">
								<h4 class="title line-clamp-1 text-color-primary">Satisfaction Guarantee</h4>
								<p class="pera text-color-tertiary line-clamp-2">There are many variations of passages
									of our
									Lorem Ipsum available but the.</p>
							</a>
						</div>
					</div>
					<div class="col-xxl-3 col-md-4 col-sm-6">
						<div class="goal-card wow fadeInUp" data-wow-delay="0.1s">
							<div class="circle-icon">
								<img src="assets/images/goal/icon-3.png" alt="img"/>
							</div>
							<a href="javascript:void(0)">
								<h4 class="title line-clamp-1 text-color-primary">New Arrival Everyday</h4>
								<p class="pera text-color-tertiary line-clamp-2">There are many variations of passages
									of our
									Lorem Ipsum available but the.</p>
							</a>
						</div>
					</div>
					<div class="col-xxl-3 col-md-4 col-sm-6">
						<div class="goal-card wow fadeInUp" data-wow-delay="0.2s">
							<div class="circle-icon">
								<img src="assets/images/goal/icon-4.png" alt="img"/>
							</div>
							<a href="javascript:void(0)">
								<h4 class="title line-clamp-1 text-color-primary">Fast & Free Shipping</h4>
								<p class="pera text-color-tertiary line-clamp-2">There are many variations of passages
									of our
									Lorem Ipsum available but the.</p>
							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="shape routedOne">
				<img src="assets/images/goal/shape.png" alt="img"/>
			</div>
		</section>
		{/* <!-- End-of goal--> */}

        {/* <!-- About area S t a r t --> */}
        <section class="about-area bottom-padding1">
            <div class="container">
                <div class="row g-4 align-items-center">
                    <div class="col-xl-6">
                        <div class="row g-4">
                            <div class="col-md-6">
                                <div class="about-gallery w-296 mb-30 wow fadeInUp" data-wow-delay="0.0s">
                                    <img src="assets/images/gallery/about-1.png" alt="img"/>
                                </div>
                                <div class="about-gallery w-296 wow fadeInUp" data-wow-delay="0.1s">
                                    <img src="assets/images/gallery/about-2.png" alt="img"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="about-gallery w-319 mb-30 mt-96 position-relative wow fadeInUp" data-wow-delay="0.2s">
                                    <img src="assets/images/gallery/about-3.png" alt="img"/>
                                    <div class="main-circle">
                                        <div class="curve">
                                            <h1 class="curve-text">Service Furniture Creative Design</h1>
                                        </div>
                                        <div class="child-circle"></div>
                                        <div class="sub-child-circle"></div>
                                    </div>
                                </div>
                                <div class="about-gallery w-319 wow fadeInUp" data-wow-delay="0.3s">
                                    <img src="assets/images/gallery/about-4.png" alt="img"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <div class="about-caption">
                            <p class="heading">Our About Us</p>
                            <div class="section-title">
                                <h4 class="title">We believe in pure and organic quality</h4>
                                <p class="pera">There are many variations of passages of Lorem Ipsum available, but the
                                    majority have
                                    suffered alteration in some form, by injected humour, or randomised words which
                                    don't look even
                                    slightl believable. If you are going to use a passage of Lorem Ipsum, you need</p>
                            </div>
                        </div>
                        <div class="goal-card">
                            <div class="circle-icon">
                                <img src="assets/images/icon/about-icon-1.png" alt="img"/>
                            </div>
                            <a href="javascript:void(0)">
                                <h4 class="title line-clamp-1 text-color-primary">Products Return Policy</h4>
                                <p class="pera text-color-tertiary line-clamp-2">Sure there isn't anything embarrassing
                                    hidden in the
                                    middle of text.</p>
                            </a>
                        </div>
                        <div class="goal-card mb-0">
                            <div class="circle-icon">
                                <img src="assets/images/icon/about-icon-2.png" alt="img"/>
                            </div>
                            <a href="javascript:void(0)">
                                <h4 class="title line-clamp-1 text-color-primary">100% Qualityful Furniture</h4>
                                <p class="pera text-color-tertiary line-clamp-2">Sure there isn't anything embarrassing
                                    hidden in the
                                    middle of text.</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="shape routedOne">
                <img src="assets/images/goal/shape.png" alt="img"/>
            </div>
        </section>
        {/* <!-- End-of about--> */}

        {/* <!-- Product-budget area S t a r t --> */}
        <section class="product-budget-area section-padding2 product-bg">
            <div class="container">
                <div class="row justify-content-center position-relative">
                    <div class="col-xl-6">
                        <div class="section-title text-center wow fadeInUp" data-wow-delay="0.0s">
                            <h4 class="title">You Can Easily Buy Our Products Within Your Budget</h4>
                        </div>
                    </div>
                </div>
                <div class="easy-step-section position-relative">
                    <div class="goal-card wow fadeInLeft" data-wow-delay="0.0s">
                        <div class="circle-icon">
                            <img src="assets/images/icon/about-icon-3.png" alt="img"/>
                            <div class="count">
                                <span class="num">01</span>
                            </div>
                        </div>
                        <a href="javascript:void(0)">
                            <h4 class="title line-clamp-1 text-color-primary">Choose Product</h4>
                            <p class="pera text-color-tertiary line-clamp-3">Randomised words which don't look ours even
                                slightly
                                believable. If you aregoing to use a If you are going to use a passage</p>
                        </a>
                    </div>
                    <div class="pointer ">
                        <svg xmlns="http://www.w3.org/2000/svg" width="182" height="23" viewBox="0 0 182 23"
                            fill="none">
                            <path
                                d="M169.374 13.2125C169.351 13.3047 169.323 13.3955 169.29 13.4844C168.668 15.1546 168.09 16.8443 167.516 18.5324C167.396 18.885 167.105 19.2362 167.449 19.7651C171.809 16.2405 176.85 13.9062 182.001 11.6831C176.702 9.35902 171.665 6.77376 167.15 3.16792C166.878 3.71317 167.171 4.06785 167.303 4.42769C167.931 6.12791 168.558 7.83279 169.227 9.51339C169.698 10.7072 169.75 12.013 169.374 13.2125Z"
                                fill="currentColor" />
                            <rect y="10.8948" width="170.684" height="1.21053" rx="0.605263" fill="currentColor" />
                        </svg>
                    </div>
                    <div class="goal-card wow fadeInLeft" data-wow-delay="0.1s">
                        <div class="circle-icon">
                            <img src="assets/images/icon/about-icon-3.png" alt="img"/>
                            <div class="count">
                                <span class="num">02</span>
                            </div>
                        </div>
                        <a href="javascript:void(0)">
                            <h4 class="title line-clamp-1 text-color-primary">Details Address</h4>
                            <p class="pera text-color-tertiary line-clamp-3">Randomised words which don't look ours even
                                slightly
                                believable. If you aregoing to use a If you are going to use a passage</p>
                        </a>
                    </div>
                    <div class="pointer ">
                        <svg xmlns="http://www.w3.org/2000/svg" width="182" height="23" viewBox="0 0 182 23"
                            fill="none">
                            <path
                                d="M169.374 13.2125C169.351 13.3047 169.323 13.3955 169.29 13.4844C168.668 15.1546 168.09 16.8443 167.516 18.5324C167.396 18.885 167.105 19.2362 167.449 19.7651C171.809 16.2405 176.85 13.9062 182.001 11.6831C176.702 9.35902 171.665 6.77376 167.15 3.16792C166.878 3.71317 167.171 4.06785 167.303 4.42769C167.931 6.12791 168.558 7.83279 169.227 9.51339C169.698 10.7072 169.75 12.013 169.374 13.2125Z"
                                fill="currentColor" />
                            <rect y="10.8948" width="170.684" height="1.21053" rx="0.605263" fill="currentColor" />
                        </svg>
                    </div>
                    <div class="goal-card wow fadeInLeft" data-wow-delay="0.3s">
                        <div class="circle-icon">
                            <img src="assets/images/icon/about-icon-3.png" alt="img"/>
                            <div class="count">
                                <span class="num">03</span>
                            </div>
                        </div>
                        <a href="javascript:void(0)">
                            <h4 class="title line-clamp-1 text-color-primary">Enjoy Products</h4>
                            <p class="pera text-color-tertiary line-clamp-3">Randomised words which don't look ours even
                                slightly
                                believable. If you aregoing to use a If you are going to use a passage</p>
                        </a>
                    </div>
                </div>
            </div>
        </section>
        {/* <!-- End-of product-budget--> */}

        {/* <!-- Team S t a r t --> */}
        <section class="team-area section-padding2">
            <div class="container">
                <div class="row">
					<div class="col-lg-12">
                        <div class="section-title">
                            <h4 class="title">Our Exclusive Team</h4>
                        </div>
                        <div class="swiper featureSwiper-active">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide">
                                    <div class="team-card">
                                        <div class="team-img position-relative">
                                            <a href="javascript:void(0)">
                                                <img src="assets/images/gallery/team-1.png" alt="img"/>
                                                <div class="team-shape">
                                                    <img src="assets/images/gallery/team-shape.png" alt="img"/>
                                                </div>
                                                <div class="social-link">
                                                    <div class="circle-icon">
                                                        <i class="ri-facebook-fill"></i>
                                                    </div>
                                                    <div class="circle-icon">
                                                        <i class="ri-linkedin-fill"></i>
                                                    </div>
                                                    <div class="circle-icon">
                                                        <i class="ri-twitter-fill"></i>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div class="team-content">
                                            <a href="javascript:void(0)">
                                                <h4 class="title">Deniella Rhodes</h4>
                                                <p class="pera">Chief Executive Officer</p>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="team-card">
                                        <div class="team-img position-relative">
                                            <a href="javascript:void(0)">
                                                <img src="assets/images/gallery/team-2.png" alt="img"/>
                                                <div class="team-shape">
                                                    <img src="assets/images/gallery/team-shape.png" alt="img"/>
                                                </div>
                                                <div class="social-link">
                                                    <div class="circle-icon">
                                                        <i class="ri-facebook-fill"></i>
                                                    </div>
                                                    <div class="circle-icon">
                                                        <i class="ri-linkedin-fill"></i>
                                                    </div>
                                                    <div class="circle-icon">
                                                        <i class="ri-twitter-fill"></i>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div class="team-content">
                                            <a href="javascript:void(0)">
                                                <h4 class="title">Davidthy Phillips</h4>
                                                <p class="pera">Account Manager</p>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="team-card">
                                        <div class="team-img position-relative">
                                            <a href="javascript:void(0)">
                                                <img src="assets/images/gallery/team-3.png" alt="img"/>
                                                <div class="team-shape">
                                                    <img src="assets/images/gallery/team-shape.png" alt="img"/>
                                                </div>
                                                <div class="social-link">
                                                    <div class="circle-icon">
                                                        <i class="ri-facebook-fill"></i>
                                                    </div>
                                                    <div class="circle-icon">
                                                        <i class="ri-linkedin-fill"></i>
                                                    </div>
                                                    <div class="circle-icon">
                                                        <i class="ri-twitter-fill"></i>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div class="team-content">
                                            <a href="javascript:void(0)">
                                                <h4 class="title">Wensleydale</h4>
                                                <p class="pera">Marketing Expert</p>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="team-card">
                                        <div class="team-img position-relative">
                                            <a href="javascript:void(0)">
                                                <img src="assets/images/gallery/team-4.png" alt="img"/>
                                                <div class="team-shape">
                                                    <img src="assets/images/gallery/team-shape.png" alt="img"/>
                                                </div>
                                                <div class="social-link">
                                                    <div class="circle-icon">
                                                        <i class="ri-facebook-fill"></i>
                                                    </div>
                                                    <div class="circle-icon">
                                                        <i class="ri-linkedin-fill"></i>
                                                    </div>
                                                    <div class="circle-icon">
                                                        <i class="ri-twitter-fill"></i>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div class="team-content">
                                            <a href="javascript:void(0)">
                                                <h4 class="title">Abubokkor A K</h4>
                                                <p class="pera">Finance Director</p>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="team-card">
                                        <div class="team-img position-relative">
                                            <a href="javascript:void(0)">
                                                <img src="assets/images/gallery/team-1.png" alt="img"/>
                                                <div class="team-shape">
                                                    <img src="assets/images/gallery/team-shape.png" alt="img"/>
                                                </div>
                                                <div class="social-link">
                                                    <div class="circle-icon">
                                                        <i class="ri-facebook-fill"></i>
                                                    </div>
                                                    <div class="circle-icon">
                                                        <i class="ri-linkedin-fill"></i>
                                                    </div>
                                                    <div class="circle-icon">
                                                        <i class="ri-twitter-fill"></i>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div class="team-content">
                                            <a href="javascript:void(0)">
                                                <h4 class="title">Deniella Rhodes</h4>
                                                <p class="pera">Chief Executive Officer</p>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="team-card">
                                        <div class="team-img position-relative">
                                            <a href="javascript:void(0)">
                                                <img src="assets/images/gallery/team-2.png" alt="img"/>
                                                <div class="team-shape">
                                                    <img src="assets/images/gallery/team-shape.png" alt="img"/>
                                                </div>
                                                <div class="social-link">
                                                    <div class="circle-icon">
                                                        <i class="ri-facebook-fill"></i>
                                                    </div>
                                                    <div class="circle-icon">
                                                        <i class="ri-linkedin-fill"></i>
                                                    </div>
                                                    <div class="circle-icon">
                                                        <i class="ri-twitter-fill"></i>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div class="team-content">
                                            <a href="javascript:void(0)">
                                                <h4 class="title">Davidthy Phillips</h4>
                                                <p class="pera">Account Manager</p>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="team-card">
                                        <div class="team-img position-relative">
                                            <a href="javascript:void(0)">
                                                <img src="assets/images/gallery/team-3.png" alt="img"/>
                                                <div class="team-shape">
                                                    <img src="assets/images/gallery/team-shape.png" alt="img"/>
                                                </div>
                                                <div class="social-link">
                                                    <div class="circle-icon">
                                                        <i class="ri-facebook-fill"></i>
                                                    </div>
                                                    <div class="circle-icon">
                                                        <i class="ri-linkedin-fill"></i>
                                                    </div>
                                                    <div class="circle-icon">
                                                        <i class="ri-twitter-fill"></i>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div class="team-content">
                                            <a href="javascript:void(0)">
                                                <h4 class="title">Wensleydale</h4>
                                                <p class="pera">Marketing Expert</p>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="team-card">
                                        <div class="team-img position-relative">
                                            <a href="javascript:void(0)">
                                                <img src="assets/images/gallery/team-4.png" alt="img"/>
                                                <div class="team-shape">
                                                    <img src="assets/images/gallery/team-shape.png" alt="img"/>
                                                </div>
                                                <div class="social-link">
                                                    <div class="circle-icon">
                                                        <i class="ri-facebook-fill"></i>
                                                    </div>
                                                    <div class="circle-icon">
                                                        <i class="ri-linkedin-fill"></i>
                                                    </div>
                                                    <div class="circle-icon">
                                                        <i class="ri-twitter-fill"></i>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div class="team-content">
                                            <a href="javascript:void(0)">
                                                <h4 class="title">Abubokkor A K</h4>
                                                <p class="pera">Finance Director</p>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-button-next swiper-common-btn"><i class="ri-arrow-right-s-line"></i></div>
                            <div class="swiper-button-prev swiper-common-btn"><i class="ri-arrow-left-s-line"></i></div>
                        </div>						
					</div>
				</div>
            </div>
        </section>
        {/* <!-- End of team --> */}

        {/* <!-- Brand S t a r t --> */}
        <section class="brand-area pt-0">
            <div class="container">
                <div class="row">
					<div class="col-lg-12">
                        <div class="section-title">
                            <h4 class="title">Brands</h4>
                        </div>
                        <div class="swiper brandSwiper-active">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide">
                                    <img src="assets/images/brand/1.svg" alt="img"/>
                                </div>
                                <div class="swiper-slide">
                                    <img src="assets/images/brand/2.svg" alt="img"/>
                                </div>
                                <div class="swiper-slide">
                                    <img src="assets/images/brand/3.svg" alt="img"/>
                                </div>
                                <div class="swiper-slide">
                                    <img src="assets/images/brand/4.svg" alt="img"/>
                                </div>
                                <div class="swiper-slide">
                                    <img src="assets/images/brand/5.svg" alt="img"/>
                                </div>
                                <div class="swiper-slide">
                                    <img src="assets/images/brand/6.svg" alt="img"/>
                                </div>
                                <div class="swiper-slide">
                                    <img src="assets/images/brand/7.svg" alt="img"/>
                                </div>
                                <div class="swiper-slide">
                                    <img src="assets/images/brand/8.svg" alt="img"/>
                                </div>
                                <div class="swiper-slide">
                                    <img src="assets/images/brand/1.svg" alt="img"/>
                                </div>
                                <div class="swiper-slide">
                                    <img src="assets/images/brand/2.svg" alt="img"/>
                                </div>
                                <div class="swiper-slide">
                                    <img src="assets/images/brand/3.svg" alt="img"/>
                                </div>
                            </div>
                            <div class="swiper-button-next swiper-common-btn"><i class="ri-arrow-right-s-line"></i></div>
                            <div class="swiper-button-prev swiper-common-btn"><i class="ri-arrow-left-s-line"></i></div>
                        </div>						
					</div>
				</div>
            </div>
        </section>
        {/* <!-- End of Brand --> */}

        {/* <!-- Testimonial S t a r t --> */}
        <section class="testimonial-area section-padding2">
            <div class="container">
                <div class="row">
					<div class="col-lg-12">
                        <div class="section-title text-center">
                            <h4 class="title">What our clients say </h4>
                        </div>
                        <div class="swiper testimonialSwiper-active">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide">
                                    <div class="testimonial-card">
                                        <div class="shape routedOne">
                                            <img src="assets/images/icon/quote.png" alt="img"/>
                                        </div>
                                        <p class="pera line-clamp-4">
                                            All the Lorem Ipsum generatolrs on the In our ternet repeat predefined chunks as
                                            necessary ki hol
                                            making
                                            true generator on the Internet a our combned with a
                                            of model sentence
                                        </p>
                                        <div class="user-info">
                                            <div class="user-img">
                                                <img src="assets/images/gallery/testimonial-1.png" alt="img"/>
                                            </div>
                                            <h4 class="user-name line-clamp-1">Rhodes Jhon</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="testimonial-card">
                                        <div class="shape routedOne">
                                            <img src="assets/images/icon/quote.png" alt="img"/>
                                        </div>
                                        <p class="pera line-clamp-4">
                                            All the Lorem Ipsum generatolrs on the In our ternet repeat predefined chunks as
                                            necessary ki hol
                                            making
                                            true generator on the Internet a our combned with a
                                            of model sentence
                                        </p>
                                        <div class="user-info">
                                            <div class="user-img">
                                                <img src="assets/images/gallery/testimonial-2.png" alt="img"/>
                                            </div>
                                            <h4 class="user-name line-clamp-1">Steel Golden Agave</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="testimonial-card">
                                        <div class="shape routedOne">
                                            <img src="assets/images/icon/quote.png" alt="img"/>
                                        </div>
                                        <p class="pera line-clamp-4">
                                            All the Lorem Ipsum generatolrs on the In our ternet repeat predefined chunks as
                                            necessary ki hol
                                            making
                                            true generator on the Internet a our combned with a
                                            of model sentence
                                        </p>
                                        <div class="user-info">
                                            <div class="user-img">
                                                <img src="assets/images/gallery/testimonial-3.png" alt="img"/>
                                            </div>
                                            <h4 class="user-name line-clamp-1">Juliyet Jhon</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="testimonial-card">
                                        <div class="shape routedOne">
                                            <img src="assets/images/icon/quote.png" alt="img"/>
                                        </div>
                                        <p class="pera line-clamp-4">
                                            All the Lorem Ipsum generatolrs on the In our ternet repeat predefined chunks as
                                            necessary ki hol
                                            making
                                            true generator on the Internet a our combned with a
                                            of model sentence
                                        </p>
                                        <div class="user-info">
                                            <div class="user-img">
                                                <img src="assets/images/gallery/testimonial-1.png" alt="img"/>
                                            </div>
                                            <h4 class="user-name line-clamp-1">Rhodes Jhon</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="testimonial-card">
                                        <div class="shape routedOne">
                                            <img src="assets/images/icon/quote.png" alt="img"/>
                                        </div>
                                        <p class="pera line-clamp-4">
                                            All the Lorem Ipsum generatolrs on the In our ternet repeat predefined chunks as
                                            necessary ki hol
                                            making
                                            true generator on the Internet a our combned with a
                                            of model sentence
                                        </p>
                                        <div class="user-info">
                                            <div class="user-img">
                                                <img src="assets/images/gallery/testimonial-2.png" alt="img"/>
                                            </div>
                                            <h4 class="user-name line-clamp-1">Steel Golden Agave</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="testimonial-card">
                                        <div class="shape routedOne">
                                            <img src="assets/images/icon/quote.png" alt="img"/>
                                        </div>
                                        <p class="pera line-clamp-4">
                                            All the Lorem Ipsum generatolrs on the In our ternet repeat predefined chunks as
                                            necessary ki hol
                                            making
                                            true generator on the Internet a our combned with a
                                            of model sentence
                                        </p>
                                        <div class="user-info">
                                            <div class="user-img">
                                                <img src="assets/images/gallery/testimonial-3.png" alt="img"/>
                                            </div>
                                            <h4 class="user-name line-clamp-1">Juliyet Jhon</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-pagination"></div>
                        </div>					
					</div>
				</div>
            </div>
        </section>
        {/* <!-- End of testimonial --> */}

    </main>
    
    <Footer/>
    {/* <!-- End-of Footer --> */}
    </>
  )
}

export default About